module.exports = __webpack_public_path__ + "static/media/logo-swipeit-1.80799d9c.png";